<template lang="pug">
.div.notes-styled-panel
  //Notes
  .tw-flex.tw-justify-between.tw-items-center.tw-mb-4
    .tw-flex.tw-items-center.tw-gap-2
      i.fa-solid.fa-sticky-note.tw-text-yellow-500.tw-text-lg
      h5.tw-text-gray-700.tw-font-medium.tw-m-0 {{$I18n.t('vue.notes_detail_table_panel.subtitle_'+dataKindNote)}}
      span.tw-px-2.tw-py-1.tw-rounded-full.tw-text-xs.tw-bg-gray-100.tw-text-gray-600(v-if="items.length > 0")
        | {{items.length}} note(s)
    create-note-modal(
      :data-id='record.id' 
      :data-kind-note='record.kind'
      :data-model='dataModel'
      :data-note-kind-visible='dataNoteKindVisible'
      @created='retrievenotes'
    )

  //- Leyenda de visibilidad
  .tw-flex.tw-gap-4.tw-mb-3.tw-text-xs.tw-text-gray-500(v-if='!emptyItems')
    span
      i.fa-solid.fa-eye.tw-text-green-500.tw-mr-1
      | Visible
    span
      i.fa-solid.fa-eye-slash.tw-text-red-400.tw-mr-1
      | Hidden

  //- Lista de notas mejorada
  .tw-space-y-3(v-if='!emptyItems')
    .tw-bg-white.tw-rounded-lg.tw-border.tw-border-gray-200.tw-p-4.tw-shadow-sm(
      v-for="(item, index) in items" 
      :key="item.id"
      class="hover:tw-border-yellow-300 hover:tw-shadow-md tw-transition-all"
    )
      .tw-flex.tw-justify-between.tw-items-start
        //- Contenido de la nota
        .tw-flex-1
          .tw-flex.tw-items-start.tw-gap-3
            //- Icono de nota
            .tw-w-8.tw-h-8.tw-rounded-full.tw-bg-yellow-100.tw-flex.tw-items-center.tw-justify-center.tw-flex-shrink-0
              i.fa-solid.fa-sticky-note.tw-text-yellow-500.tw-text-sm
            //- Texto
            .tw-flex-1
              p.tw-text-gray-700.tw-m-0.tw-leading-relaxed {{item.description}}
              //- Badges de visibilidad
              .tw-flex.tw-gap-2.tw-mt-2
                span(
                  :class="item.visibility=='employee' || item.visibility=='everyone' ? 'tw-bg-green-100 tw-text-green-700' : 'tw-bg-red-50 tw-text-red-400'"
                  class="tw-px-2 tw-py-1 tw-rounded tw-text-xs tw-inline-flex tw-items-center tw-gap-1"
                )
                  i(:class="item.visibility=='employee' || item.visibility=='everyone' ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'")
                  | {{$I18n.t('vue.notes_detail_table_panel.visible_employee')}}
                span(
                  :class="item.visibility=='customer' || item.visibility=='everyone' ? 'tw-bg-green-100 tw-text-green-700' : 'tw-bg-red-50 tw-text-red-400'"
                  class="tw-px-2 tw-py-1 tw-rounded tw-text-xs tw-inline-flex tw-items-center tw-gap-1"
                )
                  i(:class="item.visibility=='customer' || item.visibility=='everyone' ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'")
                  | {{$I18n.t('vue.notes_detail_table_panel.visible_customer')}}
        //- Acciones
        .tw-flex.tw-gap-1.tw-ml-4
          edit-note-modal(
            :data-item='JSON.stringify(item)'
            :data-note-kind-visible='dataNoteKindVisible'
            @updated='retrievenotes'
          )
          delete-note-modal(
            :data-id='item.id'
            @deleted='retrievenotes'
          )
          
  //- Mensaje vacío
  .tw-text-center.tw-py-8.tw-text-gray-500(v-if='emptyItems')
    i.fa-solid.fa-sticky-note.tw-text-3xl.tw-text-gray-300.tw-mb-2
    p.tw-mt-2 {{$I18n.t('vue.notes_detail_table_panel.empty_items')}}

</template>
<script>

import CreateNoteModal from './create-note-modal.vue'
import DeleteNoteModal from './delete-note-modal.vue'
import EditNoteModal from './edit-note-modal.vue'
import {BackendService} from '../../services';
import CoreComponents from '../core';
import StickyTableMixin from '../../mixins/sticky_table_mixin.js';

export default {
  components:{
    'create-note-modal':CreateNoteModal,
    'delete-note-modal':DeleteNoteModal,
    'edit-note-modal':EditNoteModal,
    "app-icon-btn": CoreComponents.AppIconBtn,
  },
  mixins: [StickyTableMixin],
  props:{
    dataId: String,
    dataModel: String,
    dataKindNote: String,
    dataItems: String,
    dataNoteKindVisible: String
  },
  data: function(){
    return {
      record:{
        id: this.dataId,
        kind: this.dataKindNote
      },
      items: JSON.parse(this.dataItems),
      note_kinds_visible_option: JSON.parse(this.dataNoteKindVisible),
      labels:{
        modal_title: this.$I18n.t('vue.create_contact_modal.label_add_contact'),
        clear_btn: this.$I18n.t('vue.create_contact_modal.button_clear'),
        cancel_btn: this.$I18n.t('vue.create_contact_modal.button_cancel'),
        send_btn: this.$I18n.t('vue.create_contact_modal.button_create')
      }
    }
  },
  computed:{
    emptyItems: function(){
      return this.items.length === 0;
    }
  },
  methods:{
    retrievenotes:function(){
      location.reload();
    }
  }
}
</script>

<style scoped>
.notes-styled-panel {
  padding: 1rem;
}

.tw-space-y-3 > * + * {
  margin-top: 0.75rem;
}

.tw-transition-all {
  transition: all 0.2s ease;
}
</style>
